var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#FB0101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0682 10.69C10.1082 9.92 10.1682 9.13 10.1682 8.17V5.37H8.81816V8.17C8.81816 9.13 8.88816 9.92 8.92816 10.69H10.0682ZM9.49816 13.11C9.93816 13.11 10.2882 12.75 10.2882 12.3C10.2882 11.87 9.92816 11.51 9.49816 11.51C9.05816 11.51 8.68816 11.87 8.68816 12.3C8.68816 12.75 9.04816 13.11 9.49816 13.11Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.e6c72f7e.svg";
export { ForwardRef as ReactComponent };